import _listCacheClear_default from "./_listCacheClear.js";
import _listCacheDelete_default from "./_listCacheDelete.js";
import _listCacheGet_default from "./_listCacheGet.js";
import _listCacheHas_default from "./_listCacheHas.js";
import _listCacheSet_default from "./_listCacheSet.js";

//#region ../../node_modules/lodash-es/_ListCache.js
/**
* Creates an list cache object.
*
* @private
* @constructor
* @param {Array} [entries] The key-value pairs to cache.
*/
function ListCache(entries) {
	var index = -1, length = entries == null ? 0 : entries.length;
	this.clear();
	while (++index < length) {
		var entry = entries[index];
		this.set(entry[0], entry[1]);
	}
}
ListCache.prototype.clear = _listCacheClear_default;
ListCache.prototype["delete"] = _listCacheDelete_default;
ListCache.prototype.get = _listCacheGet_default;
ListCache.prototype.has = _listCacheHas_default;
ListCache.prototype.set = _listCacheSet_default;
var _ListCache_default = ListCache;

//#endregion
export { _ListCache_default as default };
//# sourceMappingURL=_ListCache.js.map